import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import moment from 'moment';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[msd-message-cell]',
  templateUrl: './message-cell.component.html',
  styleUrls: ['./message-cell.component.scss'],
})
export class MessageCellComponent {
  @Input() patientId: string;
  @Input() patientAvatarUrl: string;
  @Input() patientName: string;
  @Input() isNew: boolean;
  @Input() isClosed: boolean;
  @Input() subject: string;
  @Input() lastActivity: Date;
  @Input() initials: string;

  constructor(private router: Router) {
    // Nada
  }

  get formattedDate(): string {
    const momentDate = moment(this.lastActivity);

    if (momentDate.isSame(moment(), 'day')) {
      return momentDate.format('HH:mm');
    } else {
      return momentDate.format('DD.MM.yyyy');
    }
  }

  goToPatient(): void {
    if (this.patientId) {
      this.router.navigate(['/patient', this.patientId]);
    }
  }
}
